import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// --- Firebase Configuration ---
// This configuration will be automatically provided in the production environment.
// For local development, you can replace it with your own Firebase project configuration.
const firebaseConfig = typeof __firebase_config !== 'undefined' 
    ? JSON.parse(__firebase_config) 
    : {
        apiKey: "AIzaSyCh8jl__y1gZSp01icBXh2iVtFNQranHtg",
        authDomain: "newsdidtkaug.firebaseapp.com",
        projectId: "newsdidtkaug",
        storageBucket: "newsdidtkaug.firebasestorage.app",
        messagingSenderId: "170735075267",
        appId: "1:170735075267:web:6349b93c9d85c250db0776",
        measurementId: "G-4YR8SQ6ZF8"
    };
    
export const appId = typeof __app_id !== 'undefined' ? __app_id : 'default-sdidtk-app';

// --- Initialize Firebase Services ---
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
